import moment from 'moment';
import { getLastInvite } from '../../../common/garageHelpers';

export const isLessThan72HoursToCollection = (booking) => {
  const differenceBetweenNowAndColllection = moment(booking.collectionDateTimeLocal).diff(
    moment(),
    'hours',
    true
  );
  // TODO: MAKE THIS TAKE INTO ACCOUNT ONLY WEEKDAYS and CAHNCE BACK TO 48
  return differenceBetweenNowAndColllection < 72;
};

export const isMoreThan72HoursSinceCreation = (booking) => {
  const differenceBetweenNowAndCreation = moment().diff(booking.createdAt, 'hours', true);
  return differenceBetweenNowAndCreation > 72;
};

export const isBookingAutoAllocationBlocked = (booking) => {
  if (typeof booking.garageInvites === 'undefined' || booking.garageInvites.length === 0) return false;
  const lastInivite = getLastInvite(booking);

  return (
    lastInivite &&
    (lastInivite.status === 'cancelled' ||
      lastInivite.status === 'declined' ||
      lastInivite.status === 'expired' ||
      lastInivite.status === 'review')
  );
};

export const momentArray = (dateRangeArray) =>
  dateRangeArray ? dateRangeArray.map((date) => moment(date)) : null;

export const saveFiltersInLocalStorage = (localStorageKeyToSet, filtersObject) => {
  const stringifiedFilters = JSON.stringify(filtersObject);
  const encodedFilters = encodeURI(stringifiedFilters);
  localStorage.setItem(localStorageKeyToSet, encodedFilters);
};

export const getSavedFiltersFromLocalStorage = (localStorageKeyToGet) => {
  const savedFilters = localStorage.getItem(localStorageKeyToGet);
  if (!savedFilters) return {};
  const decodedFilters = decodeURI(savedFilters);
  return JSON.parse(decodedFilters);
};
